module.exports = __webpack_public_path__ + "media/images/plans/photo_location/img-location-wasou-5c67a21b6c207558cfad4615f90d8d03.png";